import { useState } from 'react';
import './print-loot-keys.styles.scss';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import { ModalAlert } from '@/components/modal/modal.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import BackButton from '@/components/SHARED/back-button/back-button.component';

const PrintLootKeys = () => {

  const screenSize = useSelector(state => state.contentData.screenSize);
  const [alertMessage, setAlertMessage] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  const gameData = location.state?.gameData;
  const lootKey = location.state?.lootKey;
  console.log('lootKey:', lootKey);
  console.log('gameData:', gameData);

  function printPage() {
    window.print();
  }

  return (
    <div className={`print-loot-keys ${screenSize}`}>
      <div className='print-loot-keys-content'>
        {

          (lootKey && gameData)
          &&
          <div>
            <div id='print-button'>
              <div className="g-space-2"></div>
              <div className='back-print-buttons'>
                <BackButton cancel={() => navigate(-1)} />
                <button

                  className='g-button'
                  onClick={() => printPage()}
                >
                  Print Loot Keys
                </button>
              </div>
              <div className="g-space-2"></div>
            </div>
            <div className='codes-list'>
              {
                Object.values(lootKey.opt_keysObj)
                  .sort((a, b) => a.id.toLowerCase() > b.id.toLowerCase() ? 1 : -1)
                  .map((code, index) => {
                    const isClaimed = !!(code.playerId && code.ts);
                    return (
                      <div
                        key={code.id}
                        className={`g-list-item code-card ${isClaimed ? 'claimed' : ''} ${(index + 1) % 16 === 0 ? 'break' : ''}`} >
                        <ImageContainer
                          src={lootKey.icon}
                          className='icon' />
                        <div className='code-card-content'>
                          <p>You earned a Loot Key!</p>
                          <h3>{code.id.toUpperCase()}</h3>

                          <p>{lootKey.name}</p>
                          {/* <p className='meta'>{lootKey.desc ?? ''}</p> */}
                        </div>
                        {
                          isClaimed &&
                          <div className='claimed-overlay'>
                            <div className='claimed-stamp'>
                              <span className='claimed-label'>Claimed</span>
                              <span className='claimed-date'>{format(new Date(code.ts), 'P')}</span>
                            </div>
                          </div>
                        }
                      </div>
                    )
                  })
              }
            </div>
          </div>
        }
      </div>
      <ModalAlert
        show={alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage}
      />
    </div>
  )
}

export default PrintLootKeys